import React, { useMemo } from 'react';
import Modal from './Modal';
import Button from './Button';
import { PayrollSettings } from '../../shared/types.js';
import { calculatePeriodDates, calculatePreviousPeriodStartDate, toDateInputString } from '../utils.js';
import { ArrowUpCircleIcon } from './icons';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    payrollSettings: PayrollSettings;
}

const ReopenPeriodModal: React.FC<Props> = ({ isOpen, onClose, onConfirm, payrollSettings }) => {
    const { start: currentStart, end: currentEnd } = useMemo(() => calculatePeriodDates(payrollSettings), [payrollSettings]);

    const previousPeriod = useMemo(() => {
        if (!payrollSettings.startDate) return { start: new Date(), end: new Date() };
        try {
            const prevStartDate = calculatePreviousPeriodStartDate(payrollSettings);
            const { start, end } = calculatePeriodDates({ ...payrollSettings, startDate: toDateInputString(prevStartDate) });
            return { start, end };
        } catch(e) {
            return { start: new Date(), end: new Date() };
        }
    }, [payrollSettings]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Reopen Prior Payroll Period">
            <div className="text-center text-gray-900 dark:text-white">
                <ArrowUpCircleIcon className="w-16 h-16 text-blue-500 mx-auto mb-4" />
                <h3 className="text-2xl font-bold mb-2">Reopen Prior Period?</h3>
                <p className="text-gray-600 dark:text-gray-300">
                    This will revert the payroll period from:
                </p>
                <p className="font-bold text-lg my-2">{currentStart.toLocaleDateString()} - {currentEnd.toLocaleDateString()}</p>
                <p className="text-gray-600 dark:text-gray-300">
                    back to the previous period:
                </p>
                <p className="font-bold text-lg my-2 text-blue-500 dark:text-blue-400">{previousPeriod.start.toLocaleDateString()} - {previousPeriod.end.toLocaleDateString()}</p>
                <p className="mt-4 p-3 bg-yellow-100 dark:bg-yellow-900/50 text-yellow-800 dark:text-yellow-300 rounded-md">
                    <strong>Note:</strong> This will unlock all entries in the reopened period, allowing them to be edited.
                </p>
                 <div className="flex justify-center gap-4 mt-8">
                    <Button variant="secondary" onClick={onClose}>Cancel</Button>
                    <Button variant="primary" onClick={onConfirm}>Reopen Period</Button>
                </div>
            </div>
        </Modal>
    );
};
export default ReopenPeriodModal;
